import { render, staticRenderFns } from "./ClubeVantagens.vue?vue&type=template&id=be9958ca&"
import script from "./ClubeVantagens.vue?vue&type=script&lang=js&"
export * from "./ClubeVantagens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports